import ca from "./ca.js";
import de from "./de.js";
import en from "./en.js";
import es from "./es.js";
import fr from "./fr.js";
import it from "./it.js";
import nl from "./nl.js";
import zh from "./zh.js";
import ja from "./ja.js";

export const messages = {
  ca,
  de,
  en,
  es,
  fr,
  it,
  nl,
  zh,
  ja,
};
